import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import StatementTemplateList from './StatementTemplateList';
import StatementReviewQueue from './StatementReviewQueue';
import SchemaManager from './SchemaManager';
import SourceTagManager from './SourceTagManager';

const WitnessStatementAdmin = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
      <Tabs value={activeTab} onChange={(e, newValue) => setActiveTab(newValue)} sx={{ mb: 2, flexShrink: 0 }}>
        <Tab label="Templates" />
        <Tab label="Review Queue" />
        <Tab label="Schema Registry" />
        <Tab label="Tag Registry" />
      </Tabs>

      <Box sx={{ flexGrow: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        {activeTab === 0 && <StatementTemplateList />}
        {activeTab === 1 && <StatementReviewQueue />}
        {activeTab === 2 && <SchemaManager />}
        {activeTab === 3 && <SourceTagManager />}
      </Box>
    </Box>
  );
};

export default WitnessStatementAdmin;
